// Dependencies imports
import React from "react";
import SemiCircleProgressBar from "react-progressbar-semicircle";
import "react-circular-progressbar/dist/styles.css";

// Local imports
import InfoIcon from "../../../../Assets/icons/infoicon.png";
import { ReactComponent as Tick } from "../../../../Assets/icons/greentick.svg";
import { ReactComponent as Wrong } from "../../../../Assets/icons/redcross.svg";
import UnderTraining from "../../../../Assets/icons/undertraining.gif";

// Style imports
import Card from "./cardstyle.module.scss";

const FloorMoppingCard = () => {
  return (
    <div className={Card.mainbigcontainer}>
      <div className={Card.topinfo}>
        <h4 className={Card.featurename}>Floor Mopping</h4>
        <img className={Card.infoicon} src={InfoIcon} alt="infoicon" />
      </div>
      {/* <div className={Card.middleholder}>
        <div className={Card.leftbigholder}>
          <div className={Card.eventsholder}>
            <h5 className={Card.featuredetails}>10:00 AM - 11:00 AM :</h5>
            <span>
              <Tick />
            </span>
          </div>
          <div className={Card.eventsholder}>
            <h5 className={Card.featuredetails}>16:00 PM - 17:00 PM :</h5>
            <span>
              <Wrong />
            </span>
          </div>
          <br />
          <button className={Card.learnmore}>Learn More</button>
        </div>
        <div className={Card.rightbigholder}>
          <SemiCircleProgressBar
            percentage={94}
            showPercentValue
            diameter={125}
            stroke="#2BA65A"
          />
          <h4 className={Card.textbelowprogress}>HYGIENE SCORE</h4>
        </div>
      </div> */}
      <div className={Card.underprogressholder}>
        <img
          src={UnderTraining}
          className={Card.undertraininggif}
          alt="undertraininggif"
        />
        <h4 className={Card.underprogress}>Training under progress</h4>
      </div>
    </div>
  );
};

export default FloorMoppingCard;
